import { useMemo } from 'react';
import dayjs from 'dayjs';

import { EUROPE_BERLIN_TIMEZONE } from '@mopla/constants';
import { ESubscriptionStatus, ISubscriptionTicket } from '@mopla/data-models';

import { useSubscription } from '../useSubscription';

interface IUseDTicketStartEndDateProps {
	currentTicket?: ISubscriptionTicket;
}

export const useDTicketStartEndDate = ({
	currentTicket,
}: IUseDTicketStartEndDateProps) => {
	const { subscriptionData: subscription } = useSubscription();
	const isPaused = subscription?.status === ESubscriptionStatus.PAUSED;

	const { startDate, endDate } = useMemo(() => {
		if (currentTicket?.status === 'VALID') {
			return {
				startDate: dayjs(currentTicket.validFrom).tz(EUROPE_BERLIN_TIMEZONE),
				endDate: dayjs(currentTicket.validTo).tz(EUROPE_BERLIN_TIMEZONE),
			};
		}

		if (isPaused) {
			// Resume date is the day after pauseEnd
			const validFromAfterPause = dayjs(subscription?.pauseEnd).add(1, 'day');
			return {
				startDate: validFromAfterPause,
				endDate: validFromAfterPause.endOf('month'),
			};
		}

		return {
			startDate: dayjs(subscription?.subscriptionStart).startOf('month'),
			endDate: dayjs(subscription?.subscriptionStart).endOf('month'),
		};
	}, [
		currentTicket,
		isPaused,
		subscription?.pauseEnd,
		subscription?.subscriptionStart,
	]);

	return { startDate, endDate };
};
